<ng-container>
  <div class="col mat-elevation-z4 installment-container">
    <div class="row installment-header" [ngClass]="{'paid-status' : installment.projectInstallmentStatus?.name?.toLowerCase() == 'paid'}">
      <div class="col-2">
        Installment Number
      </div>
      <div class="col-2">
        Installment Amount
      </div>
      <div class="col-1">
        Total Funded
      </div>
      <div class="col-1">
        Total Adjusters
      </div>
      <div class="col-1">
        Remaining
      </div>
      <div class="col-1">
        Status
      </div>
      <div class="col-2">
        Original Commitment Date
      </div>
      <div class="col-2">
        <div class="row notes-action">
          <div class="col-md-9">Notes</div>
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-8">
                <div class="col-md-1 delete-installment-btn">@if (permissions?.installmentPermissions?._delete) {
                  <div class="dropdown-button" (click)="openDeleteConfirmationModal()" matTooltip="Remove installment"><i class="material-icons">delete</i></div>
                }</div>
              </div>
              <div class="col-md-4">
                <div class="dropdown-button" (click)="togglePanel()"><i class="material-icons">{{expanded ? 'arrow_drop_up' : 'arrow_drop_down'}}</i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (!readOnly) {
      <form [formGroup]="installmentForm">
        <div class="row installment-info align-top">
          <div class="col-2">
            <input class="shrink-input" formControlName="installment_number" name="installment_number" type="number" step="1">
          </div>
          <div class="col-2">
            <span>$</span>
            <input class="shrink-input" formControlName="installment_amount" name="installment_amount" currencyParser type="text" step="1">
          </div>
          <div class="col-1">
            @if (installmentForm.controls['total_funded'].value !== null) {
              {{ installmentForm.controls['total_funded'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
            }
            @if (installmentForm.controls['total_funded'].value == null) {
              --
            }
          </div>
          <div class="col-1">
            @if (installmentForm.controls['total_adjusters'].value!== null) {
              {{ installmentForm.controls['total_adjusters'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
            }
            @if (installmentForm.controls['total_adjusters'].value==null) {
              --
            }
          </div>
          <div class="col-1">
            @if (installmentForm.controls['remaining'].value!==null) {
              {{ installmentForm.controls['remaining'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
            }
            @if (installmentForm.controls['remaining'].value == null) {
              --
            }
          </div>
          <div class="col-1">
            @if (checkPermissions($safeNavigationMigration(permissions?.installmentPermissions), 'project_installment_status_id')) {
              <select formControlName="status" style="max-width: 90%">
                <option [value]="null">--</option>
                @for (status of installmentStatuses; track status) {
                  <option [value]="status.id">{{status.name}}</option>
                }
              </select>
            }
            @if (!checkPermissions($safeNavigationMigration(permissions?.installmentPermissions), 'project_installment_status_id')) {
              {{installment.projectInstallmentStatus ? installment.projectInstallmentStatus.name : '--'}}
            }
          </div>
          <div class="col-2">
            <input type="date" formControlName="original_commitment_date" name="original_commitment_date" style="max-width: 80%">
          </div>
          <div class="col-2">
            <div class="row notes-action">
              <div class="col-md-11">
                <textarea
                  class="shrink-input"
                  formControlName="notes"
                  name="notes"
                  type="text"
                  cdkTextareaAutosize
                  [cdkAutosizeMinRows]="notesExpanded ? 3 : 1"
                  [cdkAutosizeMaxRows]="notesExpanded ? 10 : 1"
                  (focus)="notesExpanded = true"
                  (blur)="notesExpanded = false"
                ></textarea>
              </div>
              <div class="col-md-1">
                <!--          <div class="save-button" *ngIf="permissions?.installmentPermissions?._edit" (click)="updateInstallment()" matTooltip="Save Installment">-->
                <!--            <i class="material-icons">save</i>-->
              <!--          </div>-->
            </div>
          </div>
        </div>
      </div>
    </form>
  }
  @if (readOnly) {
    <div class="row installment-info">
      <div class="col-2">
        {{installmentForm.controls['installment_number'].value}}
      </div>
      <div class="col-2">
        @if (installmentForm.controls['installment_amount'].value !== null) {
          {{installmentForm.controls['installment_amount'].value | currency: 'USD': 'symbol': '1.2-2'}}
        }
        @if (installmentForm.controls['installment_amount'].value == null) {
          --
        }
      </div>
      <div class="col-1">
        @if (installmentForm.controls['total_funded'].value !== null) {
          {{ installmentForm.controls['total_funded'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
        }
        @if (installmentForm.controls['total_funded'].value == null) {
          --
        }
      </div>
      <div class="col-1">
        @if (installmentForm.controls['total_adjusters'].value !== null) {
          {{ installmentForm.controls['total_adjusters'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
        }
        @if (installmentForm.controls['total_adjusters'].value == null) {
          --
        }
      </div>
      <div class="col-1">
        @if (installmentForm.controls['remaining'].value !== null) {
          {{ installmentForm.controls['remaining'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
        }
        @if (installmentForm.controls['remaining'].value == null) {
          --
        }
      </div>
      <div class="col-1">
        @if (installment.projectInstallmentStatus!== null) {
          {{installment.projectInstallmentStatus.name}}
        }
        @if (installment.projectInstallmentStatus == null) {
          --
        }
      </div>
      <div class="col-2">
        @if (installmentForm.controls['original_commitment_date'].value !== null) {
          {{installmentForm.controls['original_commitment_date'].value}}
        }
        @if (installmentForm.controls['original_commitment_date'].value == null) {
          --
        }
      </div>
      <div class="col-2">
        {{installmentForm.controls['notes'].value}}
      </div>
    </div>
  }
  @if (expanded) {
    <div class="content-container">
      @for (funding of fundings; track funding) {
        <equity-installment-funding [funding]="funding" [parentInstallment]="installment" (removeFunding)="deleteFunding($event)" [readOnly]="readOnly" (updateInstallmentAmount)="refreshInstallment($event)"></equity-installment-funding>
      }
      @if (!readOnly) {
        <div class="row">
          <div class="col-md-2" style="font-size: 14px; align-items: center">
            <div class="row">
              <div style="max-width: 40px">
                @if (permissions?.fundingPermissions?._create) {
                  <button mat-mini-fab class="add-funding-button" (click)="openAddFundingConfirmation()">
                    <i class="material-icons">add</i>
                  </button>
                }
              </div>
              @if (permissions?.fundingPermissions?._create) {
                <div style="max-width: 70%;">
                  Add Funding
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
</ng-container>
